import Icon from 'vue-awesome/components/Icon'

Icon.register({
  nature_rounded: {
    paths: [
      {
        d: 'M13 16.12c3.37-.4 6.01-3.19 6.16-6.64.17-3.87-3.02-7.25-6.89-7.31-3.92-.05-7.1 3.1-7.1 7A6.98 6.98 0 0011 16.06V20H6c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1h-5v-3.88z'
      }
    ],
    width: '24',
    height: '24'
  }
})
